var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('NavBar'),_c('SideBar'),_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_c('Footer'),_c('aside',{staticClass:"control-sidebar control-sidebar-dark"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }